import React from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Button, Typography } from "@curves/ui-base";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants";
import { Link } from "react-router-dom";

const CyclePurchaseTipDialog = ({ className, open, sourceData, onClose }) => {
	if (!open) return null;
	const { memberID } = sourceData || {};
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>提醒</GradientColorHeader>
			<DialogContent>
				<Typography>會員有訂購健康循環訂單，提醒您修改的資料並不會更新於訂單，請檢查訂單資料是否要更新。</Typography>
			</DialogContent>
			<DialogActions>
				<Button as={Link} variant="contained" to={CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.HC)}>
					前往會員健康產品訂購單
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CyclePurchaseTipDialog;
